import { render, staticRenderFns } from "./Email-inbox.vue?vue&type=template&id=0033f5e5&"
import script from "./Email-inbox.vue?vue&type=script&lang=js&"
export * from "./Email-inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports